import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import React, { useState } from "react";
import styled from "@emotion/styled";
import EditIcon from "@mui/icons-material/Edit";
import AddAddressFrom from "../ProfileModal/AddAddressFrom";
import { useSelector } from "react-redux";
import { RegistrationStatus } from "../../common/enum";

const ManageAddresses = ({
  t,
  address,
  setConfirmationDialog,
  setModalOpen,
  setModelContent,
  setDeleteAddressId,
}) => {
  const [editAddress, setEditAddress] = useState(false);
  const [editAddressId, setAddressId] = useState();
  const [open, setOpen] = useState(false);
  const {
    auth: {
      user: { status },
    },
  } = useSelector((state) => state);
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    display: "flex",
    width: "100%",
    padding: "10px",
    position: "relative",
    alignContent: "center",
    justifyContent: "space-between",
  }));

  return (
    <>
     <Paper
    variant="outlined"
    sx={{
      display: "flex",
      flexDirection: "column",
      p: 1,
    }}
  >
      <Stack direction={"row"} justifyContent="end" className="ButtonBoxMorada">
        <Button
          onClick={() => {
            setOpen(true);
            setEditAddress(false);
          }}
          startIcon={<AddCircleOutlineIcon />}
          variant="contained"
          sx={{ borderRadius: "4px" }}
          disabled={
            status === RegistrationStatus.inActive ||
            status === RegistrationStatus.inAtivo ||
            status === RegistrationStatus.revoked
          }
        >
          {t("addAddress")}
        </Button>
      </Stack>
      <Box
      className="boxAdressMorada"
        mt={4}
        sx={{
          display: "grid",
          gridTemplateColumns: {
            lg: "auto",
          },
          gap: "30px",
          width: "100%",
          padding: 1,
        }}
      >
        {address.length > 0 &&
          address.map((d) => (
            <React.Fragment key={d.addressId}>
              {editAddress === false && open === false && (
                <Item
                  className="adressItem"
                  sx={{
                    border: address ? "2px solid #198754" : "1px solid #dddddd",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <Stack direction={"row"}>
                    <img
                      src="/static/dashboard/map.svg"
                      alt="map"
                      style={{ height: "50px" }}
                    />
                    <Box marginLeft={"10px"}>
                      <Typography fontSize={"subheading"} fontWeight={"bold"}>
                        {d.addressTitle}
                      </Typography>
                      <Typography fontSize={"subheading"}>
                        {d.addressLine} {d.locality} {d.subDivision} {d.county}{" "}
                        {d.district} {d.postalCode}
                      </Typography>
                    </Box>
                  </Stack>
                  <Button
                    onClick={() => {
                      setEditAddress(true);
                      setOpen(false);
                      setAddressId(d.addressId);
                    }}
                    sx={{ borderRadius: "4px" }}
                    startIcon={<EditIcon />}
                    disabled={
                      status === RegistrationStatus.inActive ||
                      status === RegistrationStatus.inAtivo ||
                      status === RegistrationStatus.revoked
                    }
                  >
                    {t("edit")}
                  </Button>
                </Item>
              )}
              {editAddress === true && editAddressId === d.addressId && (
                <AddAddressFrom
                  t={t}
                  editAddress={editAddress}
                  setEditAddress={setEditAddress}
                  setOpen={setOpen}
                  setConfirmationDialog={setConfirmationDialog}
                  setModalOpen={setModalOpen}
                  setModelContent={setModelContent}
                  setDeleteAddressId={setDeleteAddressId}
                  address={d}
                />
              )}
            </React.Fragment>
          ))}
        {address.length === 0 && (
          <Typography fontSize={"h5"} fontWeight={"bold"}>
            {t("noAddressToShow")}
          </Typography>
        )}
      </Box>
      {open && <AddAddressFrom t={t} setOpen={setOpen} />}
      </Paper>
    </>
  );
};

export default ManageAddresses;
